import Swiper, { Navigation, FreeMode, Pagination } from 'swiper';

/**
 * Create new slider with arrows
 * @param {String} id - className reference in DOM
 * @param {Boolean} infiniy - prams option, infinity or no
 */
export const config = async (id) => {

  new Swiper(id, {
    modules: [Navigation, FreeMode],
    spaceBetween: 16,
    navigation: {
      nextEl: `.swiper-button-next[data-id="${id.substr(1)}"]`,
      prevEl: `.swiper-button-prev[data-id="${id.substr(1)}"]`,
    },
    freeMode: true,
    slidesPerView: 4,
    slidesPerGroup: 4,
  });
};

export const configDeferCollections = async (id) => {

  new Swiper(id, {
    modules: [Navigation],
    spaceBetween: 30,
    navigation: {
      nextEl: `.swiper-button-next[data-id="${id.substr(1)}"]`,
      prevEl: `.swiper-button-prev[data-id="${id.substr(1)}"]`,
    },
    slidesPerGroup: 1,
    slidesPerView: 5,
    breakpoints: {
      1200: {
        spaceBetween: 40,
        slidesPerView: 7,
      },
    },
  });
};

export const configUpsellCart = async () => {

  new Swiper('.slider_upsell', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 25,
    loop: true,
    pagination: {
      el: `.swiper-pagination[data-id="slider_side-cart"]`,
      clickable: true,
    },
    navigation: {
      nextEl: `.swiper-button-next[data-slider="upsell"]`,
      prevEl: `.swiper-button-prev[data-slider="upsell"]`,
    },
  });
};
